import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "zakat-modal-content" }
const _hoisted_2 = { class: "billing-section" }
const _hoisted_3 = { class: "payment-section" }
const _hoisted_4 = { class: "proceed-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lifeline_donation_billing_form = _resolveComponent("lifeline-donation-billing-form")!
  const _component_lifeline_donation_gateways = _resolveComponent("lifeline-donation-gateways")!
  const _component_lifeline_donation_proceed_btn = _resolveComponent("lifeline-donation-proceed-btn")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: $setup.showModal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.showModal) = $event)),
    class: _normalizeClass(`zakat-donation-modal donation-style-1`),
    "modal-append-to-body": true,
    "append-to-body": true,
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    onClose: $setup.closeModal,
    "modal-class": "wpcm-wrapper",
    width: "500px"
  }, {
    header: _withCtx(() => _cache[1] || (_cache[1] = [
      _createElementVNode("div", { class: "zakat-modal-header" }, [
        _createElementVNode("h3", null, "Zakat Donation")
      ], -1 /* HOISTED */)
    ])),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createCommentVNode(" Zakat Amount Form "),
        _createVNode($setup["ZakatDonationForm"], {
          "zakat-amount": $props.amount,
          currencies: $setup.store.config.currencies,
          symbols: $setup.store.config.symbols,
          symbol: $setup.store.config.symbol,
          show_currency_dropdown: false
        }, null, 8 /* PROPS */, ["zakat-amount", "currencies", "symbols", "symbol"]),
        _createCommentVNode(" Billing Information "),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lifeline_donation_billing_form, {
            strings: $setup.store.config.strings,
            countries: $setup.store.config.countries,
            states: $setup.store.config.states
          }, null, 8 /* PROPS */, ["strings", "countries", "states"])
        ]),
        _createCommentVNode(" Payment Gateways "),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_lifeline_donation_gateways, {
            gateways: $setup.store.config.gateways,
            strings: $setup.store.config.strings
          }, null, 8 /* PROPS */, ["gateways", "strings"])
        ]),
        _createCommentVNode(" Proceed Button "),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_lifeline_donation_proceed_btn, {
            strings: $setup.store.config.strings
          }, null, 8 /* PROPS */, ["strings"])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}